import { Component, Input } from '@angular/core';
import { ResponsiveService, BreadcrumbItem } from '@frk/eds-components';
import { Observable } from 'rxjs';
// Used to mock sections
@Component({
  selector: 'ft-literature-order-header',
  templateUrl: './literature-order-header.html',
})
export class LiteratureOrderHeaderComponent {
  @Input() breadcrumbs: BreadcrumbItem[];
  isHandheld$: Observable<boolean>;
  constructor(private responsiveService: ResponsiveService) {
    this.isHandheld$ = this.responsiveService.isHandheld$();
  }
}
